// import { motion } from "framer-motion";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Pagination } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/pagination";

// // Animation Patterns
// const fadeInUp = {
//   hidden: { opacity: 0, y: 30 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.42 } },
// };
// const stagger = { visible: { transition: { staggerChildren: 0.09 } } };

// // Expanded Support Features
// const supportFeatures = [
//   {
//     title: "Phone Support",
//     icon: "📞",
//     items: [
//       "Dedicated account managers trained on your product",
//       "Scripted and unscripted issue reSolutions flows",
//       "Multilingual support (English, Hindi, all major Indian languages)",
//       "Automated IVR and advanced call routing",
//       "Scales from business hours to round-the-clock coverage",
//     ],
//   },
//   {
//     title: "Messaging Support",
//     icon: "💬",
//     items: [
//       "Live web chat, WhatsApp, Facebook Messenger, Insta DMs",
//       "Realtime response via AI/autoresolve and human hand-off",
//       "Social media mention/brand monitoring",
//       "Automated FAQ integration",
//       "Seamless, mobile-first experience",
//     ],
//   },
//   {
//     title: "Email Support",
//     icon: "✉️",
//     items: [
//       "Ticketing from all channels into a unified inbox",
//       "Guaranteed response SLA (as low as 2h)",
//       "Automated triage and priority assignment",
//       "Knowledge base and auto-reply integration",
//       "Per-agent and per-issue performance dashboards",
//     ],
//   },
// ];

// const additionalChannels = [
//   {
//     title: "WhatsApp & SMS",
//     icon: "📲",
//     items: [
//       "API-driven automated answers",
//       "Bulk business campaign responses",
//       "Seamless escalation to a human rep",
//     ],
//   },
//   {
//     title: "Remote Video Support",
//     icon: "🎥",
//     items: [
//       "Scheduled/instant video consultations",
//       "Screen-sharing and support for onboarding",
//       "Virtual troubleshooting for technical products",
//     ],
//   },
// ];

// // Clear, testimonial-style business stories
// const successStories = [
//   {
//     id: 1,
//     metric: "22%",
//     title: "Reduction in Customer Wait Times",
//     description:
//       "Large Indian electronics retailer, achieved via AI call routing and tiered escalation",
//     company: "Reliance Digital",
//   },
//   {
//     id: 2,
//     metric: "4.8★",
//     title: "CSAT Improvement",
//     description:
//       "SaaS startup grew satisfaction to 'world-class' via WhatsApp and remote video support",
//     company: "Zylker Technologies",
//   },
//   {
//     id: 3,
//     metric: "92%",
//     title: "First-Contact ReSolutions",
//     description:
//       "Telecom provider streamlined L1 & L2 queries into 3 languages, raising revenue retention",
//     company: "MahaTel",
//   },
//   {
//     id: 4,
//     metric: "38%",
//     title: "Support Cost Savings",
//     description:
//       "Season-driven D2C business, through on-demand 'just in time' chat outsourcing",
//     company: "Festiva Mart",
//   },
// ];

// const superlatives = [
//   {
//     title: "Scalability on Demand",
//     description:
//       "Instant transition from pilot to >100 seats for any campaign peak or season.",
//     icon: "📈",
//   },
//   {
//     title: "Industry-best Language Coverage",
//     description:
//       "Hindi, English, Marathi, Tamil, Telugu, Bengali, regional dialects—all covered natively.",
//     icon: "🌍",
//   },
//   {
//     title: "Security & Compliance",
//     description:
//       "Full DPDP/GDPR, ISO 27001, and industry vertical certifications.",
//     icon: "🛡️",
//   },
//   {
//     title: "Custom Integrations",
//     description:
//       "Connects with Freshdesk, Zoho, Salesforce, in-app, and your own stack.",
//     icon: "🔗",
//   },
//   {
//     title: "Granular Reporting",
//     description:
//       "Live dashboards: average handle time, FCR, NPS, CSAT, by campaign or region.",
//     icon: "📊",
//   },
//   {
//     title: "Best-in-Class Training",
//     description:
//       "Agents trained to mirror your brand tone and culture, not just basic scripts.",
//     icon: "🎓",
//   },
// ];

// const CustomerSupportServices = () => (
//   <div className="bg-white font-sans tracking-tight">
//     {/* Hero */}
//     <section className="relative bg-gradient-to-r from-blue-600 to-blue-900 text-white py-28 px-4 sm:px-6 lg:px-8 overflow-hidden flex items-center justify-center mb-3">
//       <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center opacity-10"></div>
//       <div className="relative z-10 text-center max-w-2xl mx-auto">
//         <motion.h1
//           initial={{ opacity: 0, y: 30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1 }}
//           className="font-extrabold text-5xl md:text-6xl mb-3 leading-tight font-sans drop-shadow"
//           style={{ letterSpacing: "-0.02em" }}
//         >
//           Customer Support <span className="text-yellow-300">Services</span>
//         </motion.h1>
//         <motion.p
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1, delay: 0.25 }}
//           className="text-xl md:text-2xl font-medium opacity-90 mb-6"
//         >
//           Delight your customers, boost retention, and scale up with India’s{" "}
//           <span className="text-yellow-200 font-bold">
//             top B2B support experts
//           </span>
//           .
//         </motion.p>
//         <motion.div
//           initial={{ opacity: 0, y: 18 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.7, delay: 0.7 }}
//           className="flex justify-center gap-5 flex-wrap mt-6"
//         >
//           <a
//             href="#contact"
//             className="bg-yellow-400 text-blue-900 font-bold px-8 py-3 rounded-lg shadow hover:bg-yellow-300 transition"
//           >
//             Get a Quote
//           </a>
//           <a
//             href="#contact"
//             className="border-2 border-white px-8 py-3 rounded-lg font-bold hover:bg-white/10 transition text-white"
//           >
//             Talk to Support Expert
//           </a>
//         </motion.div>
//       </div>
//     </section>

//     {/* Intro Section */}
//     <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
//       <motion.div
//         initial="hidden"
//         whileInView="visible"
//         variants={stagger}
//         viewport={{ once: true }}
//         className="grid md:grid-cols-2 gap-14 items-center"
//       >
//         <motion.div variants={fadeInUp}>
//           <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
//             Why Outsource Customer Support with Augere?
//           </h2>
//           <p className="text-lg text-gray-700 mb-7">
//             We provide true <strong>brand-aligned service</strong>—support
//             agents who learn your business, deliver empathy, and become your
//             growth partners. Get multilingual, omnichannel, and analytics-driven
//             support for every scale.
//           </p>
//           <ul className="space-y-2">
//             {[
//               "24/7, multilingual, omni-channel",
//               "Rapid agent onboarding & ramp-up",
//               "Quality focus: CSAT, NPS, FCR targets",
//               "Plug-and-play with your existing stack",
//             ].map((item, idx) => (
//               <motion.li
//                 key={idx}
//                 variants={fadeInUp}
//                 className="flex items-start"
//               >
//                 <svg
//                   className="w-6 h-6 text-blue-600 mr-3"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     d="M5 13l4 4L19 7"
//                   />
//                 </svg>
//                 <span className="text-gray-800">{item}</span>
//               </motion.li>
//             ))}
//           </ul>
//         </motion.div>
//         <motion.div
//           variants={fadeInUp}
//           className="bg-blue-100 rounded-3xl overflow-hidden shadow-xl"
//         >
//           <img
//             src="https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&w=900&q=80"
//             alt="Friendly support team"
//             className="w-full h-[320px] object-cover object-center"
//           />
//         </motion.div>
//       </motion.div>
//     </section>

//     {/* Support Features */}
//     <section className="py-20 bg-gradient-to-br from-gray-50 to-slate-100">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           variants={stagger}
//           className="text-center mb-14"
//         >
//           <motion.h2
//             variants={fadeInUp}
//             className="text-3xl font-bold text-blue-900 mb-3"
//           >
//             Channels We Cover
//           </motion.h2>
//           <motion.p
//             variants={fadeInUp}
//             className="text-lg text-blue-700 max-w-2xl mx-auto"
//           >
//             Unified support across phone, chat, email, WhatsApp, and remote
//             video
//           </motion.p>
//         </motion.div>

//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           variants={stagger}
//           className="grid md:grid-cols-3 gap-9"
//         >
//           {[...supportFeatures, ...additionalChannels].map((feature, i) => (
//             <motion.div
//               key={feature.title}
//               variants={fadeInUp}
//               whileHover={{ y: -8, scale: 1.03 }}
//               className="bg-white p-8 rounded-xl shadow-md hover:shadow-blue-100 border border-gray-100 transition-all"
//             >
//               <div className="text-4xl mb-3">{feature.icon}</div>
//               <h3 className="text-xl font-extrabold text-blue-900 mb-2">
//                 {feature.title}
//               </h3>
//               <ul className="space-y-2 text-gray-700 text-base">
//                 {feature.items.map((it, idx) => (
//                   <li key={idx} className="flex items-start">
//                     <svg
//                       className="h-5 w-5 text-blue-500 mr-2 mt-1"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M5 13l4 4L19 7"
//                       />
//                     </svg>
//                     <span>{it}</span>
//                   </li>
//                 ))}
//               </ul>
//             </motion.div>
//           ))}
//         </motion.div>
//       </div>
//     </section>

//     {/* Comparative Solutionss */}
//     <section className="py-20 bg-white border-t border-b border-gray-100">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           variants={stagger}
//           className="text-center mb-14"
//         >
//           <motion.h2
//             variants={fadeInUp}
//             className="text-3xl font-bold text-blue-900 mb-2"
//           >
//             Tailored For Every Size
//           </motion.h2>
//           <motion.p variants={fadeInUp} className="text-lg text-gray-700 mb-5">
//             Small business? High-growth scaleup? Massive enterprise? We match
//             each plan to your needs.
//           </motion.p>
//         </motion.div>
//         <div className="grid md:grid-cols-2 min-[900px]:grid-cols-3 gap-8">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true }}
//             variants={fadeInUp}
//             className="bg-blue-50 border border-blue-200 rounded-2xl px-7 py-8"
//           >
//             <h3 className="text-xl font-bold text-blue-900 mb-3">
//               For Startups / SMBs
//             </h3>
//             <ul className="list-disc pl-5 text-gray-700 space-y-2">
//               <li>Affordable, scalable plans</li>
//               <li>Brand-aligned scripting</li>
//               <li>No long-term contracts</li>
//               <li>Flexible hours and peak season ramp-ups</li>
//             </ul>
//           </motion.div>
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true }}
//             variants={fadeInUp}
//             className="bg-yellow-50 border border-yellow-200 rounded-2xl px-7 py-8"
//           >
//             <h3 className="text-xl font-bold text-orange-800 mb-3">
//               For Enterprises
//             </h3>
//             <ul className="list-disc pl-5 text-gray-700 space-y-2">
//               <li>24/7/365 custom teams (100+ agents)</li>
//               <li>Dedicated account and QA managers</li>
//               <li>Custom analytics/NPS reports</li>
//               <li>SLA / KPI guarantee</li>
//               <li>API + CRM integration</li>
//             </ul>
//           </motion.div>
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true }}
//             variants={fadeInUp}
//             className="bg-green-50 border border-green-200 rounded-2xl px-7 py-8"
//           >
//             <h3 className="text-xl font-bold text-green-900 mb-3">
//               For Seasonal / D2C / Hybrid
//             </h3>
//             <ul className="list-disc pl-5 text-gray-700 space-y-2">
//               <li>Elastic, surge-ready staffing</li>
//               <li>On-demand chat or phone support</li>
//               <li>Quick launch (&lt;48h provisioning)</li>
//               <li>Global or India-only channels</li>
//             </ul>
//           </motion.div>
//         </div>
//       </div>
//     </section>

//     {/* Why Us */}
//     <section className="py-20 bg-slate-100">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           variants={stagger}
//           className="text-center mb-12"
//         >
//           <motion.h2
//             variants={fadeInUp}
//             className="text-3xl font-bold text-blue-900 mb-2"
//           >
//             Why Choose <span className="text-yellow-500">Augere</span>
//           </motion.h2>
//           <motion.p variants={fadeInUp} className="text-lg text-blue-900 mb-3">
//             Setting the standard for outsourced support across India & global
//             markets.
//           </motion.p>
//         </motion.div>
//         <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
//           {superlatives.map((item, i) => (
//             <motion.div
//               key={item.title}
//               initial="hidden"
//               whileInView="visible"
//               viewport={{ once: true }}
//               variants={fadeInUp}
//               whileHover={{ scale: 1.03 }}
//               className="bg-white px-7 py-8 rounded-2xl shadow-sm border transition"
//             >
//               <div className="text-3xl mb-2">{item.icon}</div>
//               <h3 className="font-bold text-blue-900 mb-1">{item.title}</h3>
//               <p className="text-gray-700">{item.description}</p>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </section>

//     {/* Success Stories */}
//     <section className="py-20 bg-white border-t border-b border-gray-100">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           variants={stagger}
//           className="text-center mb-14"
//         >
//           <motion.h2
//             variants={fadeInUp}
//             className="text-3xl font-bold text-blue-900 mb-3"
//           >
//             Success Stories
//           </motion.h2>
//           <motion.p variants={fadeInUp} className="text-lg text-gray-700">
//             Proof of business impact and ROI from recent Augere support
//             partnerships.
//           </motion.p>
//         </motion.div>
//         <div>
//           <Swiper
//             slidesPerView={1}
//             spaceBetween={20}
//             loop={true}
//             autoplay={{ delay: 4200, disableOnInteraction: false }}
//             pagination={{ clickable: true }}
//             breakpoints={{
//               640: { slidesPerView: 2 },
//               1024: { slidesPerView: 4 },
//             }}
//             modules={[Autoplay, Pagination]}
//             className="pb-9"
//           >
//             {successStories.map((story) => (
//               <SwiperSlide key={story.id}>
//                 <motion.div
//                   className="bg-blue-50 p-7 rounded-xl h-full shadow border border-blue-100 hover:shadow-blue-100 transition flex flex-col"
//                   whileHover={{ y: -6, scale: 1.02 }}
//                 >
//                   <div className="text-4xl font-bold text-blue-600 mb-1">
//                     {story.metric}
//                   </div>
//                   <div className="text-lg font-semibold text-blue-900 mb-2">
//                     {story.title}
//                   </div>
//                   <div className="text-gray-700 mb-2 text-base">
//                     {story.description}
//                   </div>
//                   <div className="mt-auto text-sm font-medium text-gray-500">
//                     {story.company}
//                   </div>
//                 </motion.div>
//               </SwiperSlide>
//             ))}
//           </Swiper>
//         </div>
//       </div>
//     </section>

//     {/* CTA */}
//     <section className="py-20 bg-gradient-to-r from-blue-700 to-blue-900 text-white">
//       <div className="max-w-4xl mx-auto text-center">
//         <motion.h2
//           initial={{ opacity: 0, y: 22 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.5 }}
//           className="text-3xl md:text-4xl font-extrabold mb-6"
//           style={{ letterSpacing: "-0.02em" }}
//         >
//           Ready to Scale Your Support?
//         </motion.h2>
//         <motion.p
//           initial={{ opacity: 0, y: 14 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.16, duration: 0.46 }}
//           className="text-lg md:text-xl mb-8 max-w-2xl mx-auto"
//         >
//           Contact our team for a customized support plan—built for your
//           industry, budget, and mission.
//         </motion.p>
//         <motion.div
//           initial={{ opacity: 0, y: 11 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.23, duration: 0.34 }}
//           className="flex flex-col sm:flex-row justify-center gap-4"
//         >
//           <a
//             href="tel:+919834567890"
//             className="px-8 py-3 bg-white hover:bg-gray-100 text-blue-700 font-bold rounded-lg transition shadow"
//           >
//             +91 7021216035/8828357920
//           </a>
//           <a
//             href="#contact"
//             className="px-8 py-3 border-2 border-white text-white font-bold rounded-lg hover:bg-white hover:text-blue-800 transition"
//           >
//             Get a Quote
//           </a>
//         </motion.div>
//       </div>
//     </section>
//   </div>
// );

// export default CustomerSupportServices;

import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import customer1 from "./images/call.jpg";
import customer2 from "./images/girl.jpg";

// Animation Patterns
const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.42 } },
};
const stagger = { visible: { transition: { staggerChildren: 0.09 } } };

// Expanded Support Features
const supportFeatures = [
  {
    title: "Phone Support",
    icon: "📞",
    items: [
      "Dedicated account managers trained on your product",
      "Scripted and unscripted issue reSolutions flows",
      "Multilingual support (English, Hindi, all major Indian languages)",
      "Automated IVR and advanced call routing",
      "Scales from business hours to round-the-clock coverage",
    ],
  },
  {
    title: "Messaging Support",
    icon: "💬",
    items: [
      "Live web chat, WhatsApp, Facebook Messenger, Insta DMs",
      "Realtime response via AI/autoresolve and human hand-off",
      "Social media mention/brand monitoring",
      "Automated FAQ integration",
      "Seamless, mobile-first experience",
    ],
  },
  {
    title: "Email Support",
    icon: "✉️",
    items: [
      "Ticketing from all channels into a unified inbox",
      "Guaranteed response SLA (as low as 2h)",
      "Automated triage and priority assignment",
      "Knowledge base and auto-reply integration",
      "Per-agent and per-issue performance dashboards",
    ],
  },
];

const additionalChannels = [
  {
    title: "WhatsApp & SMS",
    icon: "📲",
    items: [
      "API-driven automated answers",
      "Bulk business campaign responses",
      "Seamless escalation to a human rep",
    ],
  },
  {
    title: "Remote Video Support",
    icon: "🎥",
    items: [
      "Scheduled/instant video consultations",
      "Screen-sharing and support for onboarding",
      "Virtual troubleshooting for technical products",
    ],
  },
];

// Clear, testimonial-style business stories
const successStories = [
  {
    id: 1,
    metric: "22%",
    title: "Reduction in Customer Wait Times",
    description:
      "Large Indian electronics retailer, achieved via AI call routing and tiered escalation",
    company: "Reliance Digital",
  },
  {
    id: 2,
    metric: "4.8★",
    title: "CSAT Improvement",
    description:
      "SaaS startup grew satisfaction to 'world-class' via WhatsApp and remote video support",
    company: "Zylker Technologies",
  },
  {
    id: 3,
    metric: "92%",
    title: "First-Contact ReSolutions",
    description:
      "Telecom provider streamlined L1 & L2 queries into 3 languages, raising revenue retention",
    company: "MahaTel",
  },
  {
    id: 4,
    metric: "38%",
    title: "Support Cost Savings",
    description:
      "Season-driven D2C business, through on-demand 'just in time' chat outsourcing",
    company: "Festiva Mart",
  },
];

const superlatives = [
  {
    title: "Scalability on Demand",
    description:
      "Instant transition from pilot to >100 seats for any campaign peak or season.",
    icon: "📈",
  },
  {
    title: "Industry-best Language Coverage",
    description:
      "English, French, German, Hindi, Punjabi, Marathi, Gujrati and more.",
    icon: "🌍",
  },
  {
    title: "Security & Compliance",
    description:
      "Full DPDP/GDPR, ISO 27001, and industry vertical certifications.",
    icon: "🛡️",
  },
  {
    title: "Custom Integrations",
    description:
      "Connects with Freshdesk, Zoho, Salesforce, in-app, and your own stack.",
    icon: "🔗",
  },
  {
    title: "Granular Reporting",
    description:
      "Live dashboards: average handle time, FCR, NPS, CSAT, by campaign or region.",
    icon: "📊",
  },
  {
    title: "Best-in-Class Training",
    description:
      "Agents trained to mirror your brand tone and culture, not just basic scripts.",
    icon: "🎓",
  },
];

const telecallingServices = {
  title: "Our Specialized Telecalling Services",
  description:
    "At Augere, we transform lead generation through data-driven telecalling Solutionss. Our strategic approach combines deep market insights with personalized outreach to convert prospects into loyal customers.",
  capabilities: [
    {
      title: "Targeted Campaigns",
      items: [
        "Strategic audience segmentation using advanced data analytics",
        "Personalized messaging tailored to each prospect's needs",
        "A/B testing of call scripts to optimize conversion rates",
        "Continuous performance tracking and strategy refinement",
      ],
    },
    {
      title: "Lead Qualification & Nurturing",
      items: [
        "Expert callers trained in sophisticated qualification techniques",
        "Structured scripts to identify high-potential prospects",
        "Lead scoring system to prioritize follow-up actions",
        "Progressive engagement strategies to move leads through the funnel",
      ],
    },
    {
      title: "Event Support & Re-engagement",
      items: [
        "Pre- and post-event calling to maximize participation",
        "Systematic follow-ups to reactivate dormant leads",
        "Feedback collection to gauge event success",
      ],
    },
  ],
  whyChoose: [
    "Data-driven targeting for higher conversion rates",
    "Multilingual Global Coverage ",
    "Fully customizable campaigns aligned with your goals",
    "Scalable Solutionss from small campaigns to enterprise programs",
    "Strict compliance with DPDP, GDPR, and industry regulations",
    "Comprehensive analytics and performance insights",
  ],
  results: [
    {
      metric: "160%",
      description: "increase in qualified leads for healthcare client",
    },
    {
      metric: "45%",
      description: "higher conversion rates for automotive supplier",
    },
    {
      metric: "70%",
      description: "increase in event attendance through targeted outreach",
    },
  ],
};

const CustomerSupportServices = () => (
  <div className="bg-white font-sans tracking-tight">
    {/* Hero */}
    <section className="relative bg-gradient-to-r from-blue-600 to-blue-900 text-white py-28 px-4 sm:px-6 lg:px-8 overflow-hidden flex items-center justify-center mb-3">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center opacity-10"></div>
      <div className="relative z-10 text-center max-w-2xl mx-auto">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="font-extrabold text-5xl md:text-6xl mb-3 leading-tight font-sans drop-shadow"
          style={{ letterSpacing: "-0.02em" }}
        >
          Customer Support <span className="text-yellow-300">Services</span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.25 }}
          className="text-xl md:text-2xl font-medium opacity-90 mb-6"
        >
          Delight your customers, boost retention, and scale up with India's{" "}
          <span className="text-yellow-200 font-bold">
            top B2B support experts
          </span>
          .
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.7 }}
          className="flex justify-center gap-5 flex-wrap mt-6"
        >
          <a
            href="/contact"
            className="bg-yellow-400 text-blue-900 font-bold px-8 py-3 rounded-lg shadow hover:bg-yellow-300 transition"
          >
            Get a Quote
          </a>
          <a
            href="/contact"
            className="border-2 border-white px-8 py-3 rounded-lg font-bold hover:bg-white/10 transition text-white"
          >
            Talk to Support Expert
          </a>
        </motion.div>
      </div>
    </section>

    {/* Intro Section */}
    <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <motion.div
        initial="hidden"
        whileInView="visible"
        variants={stagger}
        viewport={{ once: true }}
        className="grid md:grid-cols-2 gap-14 items-center"
      >
        <motion.div variants={fadeInUp}>
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
            Why Outsource Customer Support with Augere?
          </h2>
          <p className="text-lg text-gray-700 mb-7">
            We provide true <strong>brand-aligned service</strong>—support
            agents who learn your business, deliver empathy, and become your
            growth partners. Get multilingual, omnichannel, and analytics-driven
            support for every scale.
          </p>
          <ul className="space-y-2">
            {[
              "24/7, multilingual, omni-channel",
              "Rapid agent onboarding & ramp-up",
              "Quality focus: CSAT, NPS, FCR targets",
              "Plug-and-play with your existing stack",
            ].map((item, idx) => (
              <motion.li
                key={idx}
                variants={fadeInUp}
                className="flex items-start"
              >
                <svg
                  className="w-6 h-6 text-blue-600 mr-3"
                  stroke="currentColor"
                  strokeWidth="2"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span className="text-gray-800">{item}</span>
              </motion.li>
            ))}
          </ul>
        </motion.div>
        <motion.div
          variants={fadeInUp}
          className="bg-blue-100 rounded-3xl overflow-hidden shadow-xl"
        >
          <img
            src={customer1}
            alt="Friendly support team"
            className="w-full h-[320px] object-cover object-center"
          />
        </motion.div>
      </motion.div>
    </section>

    {/* NEW: Telecalling Services Section */}
    <section className="py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={stagger}
          className="grid md:grid-cols-2 gap-14 items-center"
        >
          <motion.div variants={fadeInUp} className="order-2 md:order-1">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              {telecallingServices.title}
            </h2>
            <p className="text-lg text-gray-700 mb-7">
              {telecallingServices.description}
            </p>

            <h3 className="text-xl font-bold text-blue-800 mb-3">
              Our Core Telecalling Capabilities
            </h3>

            {telecallingServices.capabilities.map((capability, index) => (
              <div key={index} className="mb-6">
                <h4 className="font-semibold text-blue-700 mb-2">
                  {capability.title}
                </h4>
                <ul className="list-disc pl-5 text-gray-700 space-y-1">
                  {capability.items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </motion.div>

          <motion.div
            variants={fadeInUp}
            className="order-1 md:order-2 bg-white rounded-3xl overflow-hidden shadow-xl"
          >
            <img
              src={customer2}
              alt="Professional Indian telecaller at work"
              className="w-full h-[500px] object-cover object-center"
            />
          </motion.div>
        </motion.div>

        {/* Why Choose Our Telecalling Services */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={stagger}
          className="mt-20"
        >
          <motion.h3
            variants={fadeInUp}
            className="text-2xl font-bold text-blue-900 text-center mb-8"
          >
            Why Choose Our Telecalling Services?
          </motion.h3>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {telecallingServices.whyChoose.map((item, index) => (
              <motion.div
                key={index}
                variants={fadeInUp}
                className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex items-start"
              >
                <svg
                  className="w-6 h-6 text-blue-600 mr-3 mt-0.5 flex-shrink-0"
                  stroke="currentColor"
                  strokeWidth="2"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span className="text-gray-800">{item}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Our Proven Results */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={stagger}
          className="mt-20"
        >
          <motion.h3
            variants={fadeInUp}
            className="text-2xl font-bold text-blue-900 text-center mb-8"
          >
            Our Proven Results
          </motion.h3>

          <div className="grid md:grid-cols-3 gap-8">
            {telecallingServices.results.map((result, index) => (
              <motion.div
                key={index}
                variants={fadeInUp}
                className="bg-blue-100 p-6 rounded-xl text-center"
              >
                <div className="text-4xl font-bold text-blue-700 mb-2">
                  {result.metric}
                </div>
                <div className="text-gray-700">{result.description}</div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* CTA for Telecalling */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mt-16 text-center"
        >
          <h3 className="text-2xl font-bold text-blue-900 mb-4">
            Ready to Transform Your Telecalling Results?
          </h3>
          <p className="text-lg text-gray-700 mb-6 max-w-2xl mx-auto">
            Partner with us to implement high-conversion telecalling strategies
            that deliver measurable ROI. Contact us today to get started.
          </p>
          <a
            href="/contact"
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold px-8 py-3 rounded-lg transition"
          >
            Get Started with Telecalling
          </a>
        </motion.div>
      </div>
    </section>

    {/* Support Features */}
    <section className="py-20 bg-gradient-to-br from-gray-50 to-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={stagger}
          className="text-center mb-14"
        >
          <motion.h2
            variants={fadeInUp}
            className="text-3xl font-bold text-blue-900 mb-3"
          >
            Channels We Cover
          </motion.h2>
          <motion.p
            variants={fadeInUp}
            className="text-lg text-blue-700 max-w-2xl mx-auto"
          >
            Unified support across phone, chat, email, WhatsApp, and remote
            video
          </motion.p>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={stagger}
          className="grid md:grid-cols-3 gap-9"
        >
          {[...supportFeatures, ...additionalChannels].map((feature, i) => (
            <motion.div
              key={feature.title}
              variants={fadeInUp}
              whileHover={{ y: -8, scale: 1.03 }}
              className="bg-white p-8 rounded-xl shadow-md hover:shadow-blue-100 border border-gray-100 transition-all"
            >
              <div className="text-4xl mb-3">{feature.icon}</div>
              <h3 className="text-xl font-extrabold text-blue-900 mb-2">
                {feature.title}
              </h3>
              <ul className="space-y-2 text-gray-700 text-base">
                {feature.items.map((it, idx) => (
                  <li key={idx} className="flex items-start">
                    <svg
                      className="h-5 w-5 text-blue-500 mr-2 mt-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>

    {/* Comparative Solutionss */}
    <section className="py-20 bg-white border-t border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={stagger}
          className="text-center mb-14"
        >
          <motion.h2
            variants={fadeInUp}
            className="text-3xl font-bold text-blue-900 mb-2"
          >
            Tailored For Every Size
          </motion.h2>
          <motion.p variants={fadeInUp} className="text-lg text-gray-700 mb-5">
            Small business? High-growth scaleup? Massive enterprise? We match
            each plan to your needs.
          </motion.p>
        </motion.div>
        <div className="grid md:grid-cols-2 min-[900px]:grid-cols-3 gap-8">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="bg-blue-50 border border-blue-200 rounded-2xl px-7 py-8"
          >
            <h3 className="text-xl font-bold text-blue-900 mb-3">
              For Startups / SMBs
            </h3>
            <ul className="list-disc pl-5 text-gray-700 space-y-2">
              <li>Affordable, scalable plans</li>
              <li>Outcome based pricing</li>
              <li>Brand-aligned scripting</li>
              <li>No long-term contracts</li>
              <li>Flexible hours and peak season ramp-ups</li>
            </ul>
          </motion.div>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="bg-yellow-50 border border-yellow-200 rounded-2xl px-7 py-8"
          >
            <h3 className="text-xl font-bold text-orange-800 mb-3">
              For Enterprises
            </h3>
            <ul className="list-disc pl-5 text-gray-700 space-y-2">
              <li>24/7/365 custom teams (50+ agents)</li>
              <li>Dedicated account and QA managers</li>
              <li>Custom analytics/NPS reports</li>
              <li>SLA / KPI guarantee</li>
              <li>API + CRM integration</li>
            </ul>
          </motion.div>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="bg-green-50 border border-green-200 rounded-2xl px-7 py-8"
          >
            <h3 className="text-xl font-bold text-green-900 mb-3">
              For Seasonal / D2C / Hybrid
            </h3>
            <ul className="list-disc pl-5 text-gray-700 space-y-2">
              <li>Elastic, surge-ready staffing</li>
              <li>On-demand chat or phone support</li>
              <li>Quick launch (&lt;48h provisioning)</li>
              <li>Global or India-only channels</li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>

    {/* Why Us */}
    <section className="py-20 bg-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={stagger}
          className="text-center mb-12"
        >
          <motion.h2
            variants={fadeInUp}
            className="text-3xl font-bold text-blue-900 mb-2"
          >
            Why Choose <span className="text-yellow-500">Augere</span>
          </motion.h2>
          <motion.p variants={fadeInUp} className="text-lg text-blue-900 mb-3">
            Setting the standard for outsourced support across Global markets.
          </motion.p>
        </motion.div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {superlatives.map((item, i) => (
            <motion.div
              key={item.title}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
              whileHover={{ scale: 1.03 }}
              className="bg-white px-7 py-8 rounded-2xl shadow-sm border transition"
            >
              <div className="text-3xl mb-2">{item.icon}</div>
              <h3 className="font-bold text-blue-900 mb-1">{item.title}</h3>
              <p className="text-gray-700">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* Success Stories */}
    <section className="py-20 bg-white border-t border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={stagger}
          className="text-center mb-14"
        >
          <motion.h2
            variants={fadeInUp}
            className="text-3xl font-bold text-blue-900 mb-3"
          >
            Success Stories
          </motion.h2>
          <motion.p variants={fadeInUp} className="text-lg text-gray-700">
            Proof of business impact and ROI from recent Augere support
            partnerships.
          </motion.p>
        </motion.div>
        <div>
          <Swiper
            slidesPerView={1}
            spaceBetween={20}
            loop={true}
            autoplay={{ delay: 4200, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 4 },
            }}
            modules={[Autoplay, Pagination]}
            className="pb-9"
          >
            {successStories.map((story) => (
              <SwiperSlide key={story.id}>
                <motion.div
                  className="bg-blue-50 p-7 rounded-xl h-full shadow border border-blue-100 hover:shadow-blue-100 transition flex flex-col"
                  whileHover={{ y: -6, scale: 1.02 }}
                >
                  <div className="text-4xl font-bold text-blue-600 mb-1">
                    {story.metric}
                  </div>
                  <div className="text-lg font-semibold text-blue-900 mb-2">
                    {story.title}
                  </div>
                  <div className="text-gray-700 mb-2 text-base">
                    {story.description}
                  </div>
                  <div className="mt-auto text-sm font-medium text-gray-500">
                    {story.company}
                  </div>
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="py-20 bg-gradient-to-r from-blue-700 to-blue-900 text-white">
      <div className="max-w-4xl mx-auto text-center">
        <motion.h2
          initial={{ opacity: 0, y: 22 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-3xl md:text-4xl font-extrabold mb-6"
          style={{ letterSpacing: "-0.02em" }}
        >
          Ready to Scale Your Support?
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.16, duration: 0.46 }}
          className="text-lg md:text-xl mb-8 max-w-2xl mx-auto"
        >
          Contact our team for a customized support plan—built for your
          industry, budget, and mission.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 11 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.23, duration: 0.34 }}
          className="flex flex-col sm:flex-row justify-center gap-4"
        >
          {/* <a
            href="tel:+919834567890"
            className="px-8 py-3 bg-white hover:bg-gray-100 text-blue-700 font-bold rounded-lg transition shadow"
          >
            +91 7021216035/8828357920
          </a> */}
          <a
            href="#contact"
            className="px-8 py-3 border-2 border-white text-white font-bold rounded-lg hover:bg-white hover:text-blue-800 transition"
          >
            Get a Quote
          </a>
        </motion.div>
      </div>
    </section>
  </div>
);

export default CustomerSupportServices;
